import { render } from "./nonRefund.vue?vue&type=template&id=ffbc65d6&scoped=true"
import script from "./nonRefund.vue?vue&type=script&lang=js"
export * from "./nonRefund.vue?vue&type=script&lang=js"

import "./nonRefund.vue?vue&type=style&index=0&id=ffbc65d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffbc65d6"]])

export default __exports__